// extracted by mini-css-extract-plugin
export default {"cartGrid":"cartGrid__YjQxM","firstDivider":"firstDivider__NDMxO"};